import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {accessLevelAction} from "redux/actions";


export default function AddAccessLevel(status) {

    const [accessname, setAccessname] = useState('');
    const [description, setDescription] = useState('');


    const {customers, userRole} = useSelector(state => ({
        customers: state.customers,
        userRole: state.userRole?.filter(role => role.module === "Customers")
    }));

    const dispatch = useDispatch();
    useEffect(() => {
        
    }, []);

    const addData = () =>{
        dispatch(accessLevelAction.add({ name: accessname, desc: description}));
        setAccessname('');
        setDescription('');
    } 

   
    return (
        <div>
            <h2>Add Access Level</h2>
            <form action="">
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="access_level_name">Access Level Name:</label>
                    <input type="text" className="form-control" id="access_level_name" placeholder="Enter Access Level Name" name="access_level_name" onChange={e => setAccessname(e.target.value)} value={accessname}/>
                </div>
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="description">Description:</label>
                    <input type="text" className="form-control" id="description" placeholder="Enter Description" name="description" onChange={e => setDescription(e.target.value)} value={description} />
                </div>
                <div className="form-group" style={{marginBottom:"15px",textAlign:"right"}}>
                    <button type="button" className="btn btn-primary" onClick={addData}>Submit</button>
                </div>
            </form>
        </div>
    );
}
